import React from "react";
import { ArrowRight } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

// A1-22 (operator 2026-10-12: warn, never block). After the client Excel pack
// downloads, list any cell the server found that may hold text not meant for
// the client. Extracted from Step6FreezeExport to keep that file under its cap.
export function ExportSafetyNotice({ safety }) {
  const { t } = useTranslation();
  if (!safety) return null;
  const n = safety.count;
  return (
    <div data-testid="export-xlsx-safety-warning" role="status"
      className="text-xs text-amber-800 dark:text-amber-200 bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-700/40 px-4 py-3 rounded-xl space-y-1">
      <div className="font-medium">
        {t("ui.export_safety.body", { count: n, defaultValue: `The client file downloaded, but ${n} cell${n === 1 ? "" : "s"} may contain text not meant for the client (an email address, an internal note, or another client\u2019s name). Check before sending it.` })}
      </div>
      {safety.cells.length > 0 && (
        <ul className="list-disc pl-5 tabular-nums">
          {safety.cells.map((c) => (
            <li key={`${c.tab}-${c.cell}`}>{t("ui.export_safety.sheet_cell", { tab: c.tab, cell: c.cell, defaultValue: `Sheet “${c.tab}”, cell ${c.cell}` })}</li>
          ))}
        </ul>
      )}
    </div>
  );
}


// The refused-export message and its "open the affected return" links,
// moved here unchanged from Step6FreezeExport (line cap).
export function ExportErrorNotice({ error, breaches, onOpen }) {
  const { t } = useTranslation();
  return (
    <>
      {error && (
        <div data-testid="export-xlsx-error"
          className="text-xs text-rose-700 dark:text-rose-300 bg-rose-50 dark:bg-rose-900/40 border border-rose-200 dark:border-rose-700/40 px-4 py-3 rounded-xl space-y-2">
          <div className="tabular-nums">{error}</div>
          {breaches && Object.keys(breaches).length > 0 && (
            <div
              data-testid="export-xlsx-breach-links"
              className="flex flex-wrap items-center gap-2 pt-1 mt-1 border-t border-rose-200 dark:border-rose-700/40"
            >
              <span className="tabular-nums text-[11px] text-rose-700/80 dark:text-rose-300/80 mr-1">
                {t("ui.export_safety.open_affected", { defaultValue: "Open the affected return:" })}
              </span>
              {Object.entries(breaches).map(([cc, fails]) => (
                <button
                  key={cc}
                  type="button"
                  data-testid={`export-xlsx-breach-link-${cc}`}
                  onClick={() => onOpen(cc)}
                  title={(fails || []).map((f) => f.description || f.name).join("\n")}
                  className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full border border-rose-300 dark:border-rose-700/60 bg-white dark:bg-slate-900 text-rose-700 dark:text-rose-300 hover:bg-rose-100 dark:hover:bg-rose-900/40 text-[11px] tabular-nums"
                >
                  {t("ui.export_safety.open_return", { cc, defaultValue: `→ Open ${cc} return` })}
                  <ArrowRight size={10} weight="bold" />
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default ExportSafetyNotice;
